import React from "react"
import { Typography, Button, createTheme, Divider } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { useHistory, Link } from "react-router-dom"
import { ActionButtons } from "./ActionButtons"
import { lidDescription } from "./lidDescription"
import { PlanComponentIcons } from "./PlanComponentIcons"
const toDateTimeString = date => new Date(date).toLocaleString()

const theme = createTheme()

export const PlanListItem = props => {
  const { plan } = props
  const history = useHistory()

  return (
    <Grid size={12}>
      <Grid container direction="column" spacing={2}>
        {/* Header row */}
        <Grid container direction="row" spacing={3} alignItems="stretch">
          <Grid>
            <Link to={"/plans/" + plan.id} style={{ textDecoration: "none" }}>
              <Typography color={"primary"} component="p" variant="body1">
                <b>{plan.id}</b>
              </Typography>
            </Link>
          </Grid>

          <Grid mt="3px">
            <PlanComponentIcons plan={plan} />
          </Grid>

          <Grid flex={1}>
            <Grid container direction="column">
              <Grid container justifyContent="space-between">
                <Grid>
                  <Typography component="p" variant="body1">
                    <b>
                      {`${plan.length} x ${plan.width} cm${
                        !!plan.hasLid ? ", " + lidDescription(plan) : ""
                      }`}
                    </b>
                  </Typography>
                  <Typography component="p" variant="body2">
                    {`${plan.customerCompany}, ${plan.customerCity}`}
                  </Typography>
                  <Typography component="p" variant="body2">
                    {`${plan.creator}, ${toDateTimeString(plan.created)}`}
                  </Typography>
                </Grid>

                <Grid container direction="row">
                  <Grid>
                    <ActionButtons plan={plan} />
                  </Grid>
                  <Grid ml={theme.spacing(2)}>
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{ color: "black", borderColor: "black" }}
                      onClick={() => history.push("/plans/" + plan.id)}
                    >
                      Plan anzeigen
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              <Grid mt={theme.spacing(2)}>
                <Typography component="p" variant="body2">
                  {plan.description}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Divider */}
        <Grid>
          <Divider />
        </Grid>
      </Grid>
    </Grid>
  )
}
